import TypographyPrimary from 'components/Typography/Primary'
import TypographySecondary from 'components/Typography/Secondary'

import { useState } from 'react'
import styled from 'styled-components'

const TabbedInterface = ({ result }: { result: any }) => {
    const [activeTab, setActiveTab] = useState(0)

    const currentData = result[activeTab]

    return (
        <TabContainer>
            <TabList>
                {result.map((item: any, index: number) => (
                    <Tab
                        key={item}
                        active={activeTab === index}
                        onClick={() => setActiveTab(index)}
                    >
                        <TypographySecondary value={index + 1} semiBold />
                    </Tab>
                ))}
            </TabList>
            <TabContent>
                <VideoWrapper>
                    <iframe
                        src={`https://www.youtube.com/embed/${currentData.episode_id}?start=${currentData.segment_id}`}
                        frameBorder='0'
                        allowFullScreen
                        title='YouTube Video'
                    ></iframe>
                </VideoWrapper>

                <StyledInfo>
                    <TypographyPrimary value={currentData.episode_title} bold />
                    <div>
                        <TypographySecondary value={currentData.text} size='small' />
                    </div>
                </StyledInfo>
            </TabContent>
        </TabContainer>
    )
}

export default TabbedInterface

const TabContainer = styled.div`
    display: flex;
    height: 100%;

    width: 100%;
    max-width: 1000px;
`

const TabList = styled.div`
    display: flex;
    flex-direction: column;
    width: 50px;
`

const Tab = styled.button<{ active: boolean }>`
    padding: 10px 20px;
    cursor: pointer;
    background: ${({ active, theme }) => (active ? theme.body.tableBackgroundColor : '')};
    border: none;

    outline: none;
    text-align: left;
    &:hover {
        background: ${({ theme }) => theme.body.tableBackgroundColor};
        border: 1px solid ${({ theme }) => theme.body.dialogBorder};
        border-right: none;
    }

    border: 1px solid ${({ theme, active }) => (active ? theme.body.dialogBorder : 'transparent')};
    border-right: none;
    border-radius: 10px 0 0 10px;
`

const TabContent = styled.div`
    padding: 20px;
    background: ${({ theme }) => theme.body.tableBackgroundColor};
    border: 1px solid ${({ theme }) => theme.body.dialogBorder};
    border-left: none;

    border-radius: 0px 10px 10px 10px;

    width: 100%;
    height: 100%;

    overflow: auto;

    display: flex;
    flex-direction: column;
    gap: 10px;
`

const VideoWrapper = styled.div`
    height: 100%;
    max-height: 400px;
    width: 100%;

    iframe {
        width: 100%;
        height: 100%;

        border-radius: 10px;
    }
`

const StyledInfo = styled.div`
    width: 100%;
    /* height: 100px; */
`
